import { render, staticRenderFns } from "./Staff_Form_Drawer.vue?vue&type=template&id=9488875e&"
import script from "./Staff_Form_Drawer.vue?vue&type=script&lang=js&"
export * from "./Staff_Form_Drawer.vue?vue&type=script&lang=js&"
import style0 from "./Staff_Form_Drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports